var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 72",
    style: {
      enableBackground: "new 0 0 66 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B94C7;}\n\t.st1{fill:#595959;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.99,7.67c-7.09,0-12.84,5.75-12.84,12.84S5.9,33.35,12.99,33.35s12.84-5.75,12.84-12.84 S20.08,7.67,12.99,7.67z M12.99,27.05c-3.61,0-6.54-2.93-6.54-6.54s2.93-6.54,6.54-6.54s6.54,2.93,6.54,6.54 S16.6,27.05,12.99,27.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.66,7.67c-7.09,0-12.84,5.75-12.84,12.84s5.75,12.84,12.84,12.84S51.5,27.6,51.5,20.51 S45.75,7.67,38.66,7.67z M38.66,27.05c-3.61,0-6.54-2.93-6.54-6.54s2.93-6.54,6.54-6.54s6.54,2.93,6.54,6.54 S42.28,27.05,38.66,27.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.77,35.51c-0.12,0-0.23,0.03-0.34,0.07c-0.09,0.03-0.17,0.08-0.25,0.13l-0.02-0.01l-10.28,6.7v-3.38 c0-3.13-2.54-5.67-5.67-5.67H5.82c-3.13,0-5.67,2.54-5.67,5.67v19.64c0,3.13,2.54,5.67,5.67,5.67H48.2c3.13,0,5.67-2.54,5.67-5.67 v-3.05l10.31,6.63l0.02-0.01c0.07,0.05,0.15,0.09,0.23,0.12c0.1,0.04,0.21,0.07,0.33,0.07c0.6,0,1.08-0.49,1.08-1.08V36.59 C65.85,36,65.36,35.51,64.77,35.51z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon2);
export default __webpack_public_path__ + "static/media/box_icon2.e2eb7a95491a0f366bc83f6e59815253.svg";
export { ForwardRef as ReactComponent };